import Vue from 'vue'
import api from './apis'
import CryptoJS from 'crypto-js'
import {
  Form,
  FormItem,
  Input,
  Button,
  Select,
  Option,
  Message
} from 'element-ui'

Vue.use(Button)
.use(Form)
.use(FormItem)
.use(Input)
.use(Select)
.use(Option)

Vue.prototype.$message = Message
Vue.prototype.$api = api
Vue.prototype.$md5 = (str)=>{
  return CryptoJS.MD5(str).toString()
}
Vue.prototype.$sha256 = (str)=>{
  return CryptoJS.SHA256(str).toString()
}